module.exports = __webpack_public_path__ + "static/media/builder-landing-help-3.dd0933cc.svg";